'use client'

import Link from 'next/link'
import { getIdToken } from 'firebase/auth'
import { FaLock, FaGlobeAmericas, FaFolder } from 'react-icons/fa'

import Modal from './Modal'
import TooltipModal from './TooltipModal'
import ExtendModal from './ExtendModal'

export default function CreateModals({
  isAlertModalOpen,
  setIsAlertModalOpen,
  setBookmarkModalOpen,
  isErrorModalOpen,
  setIsErrorModalOpen,
  errorText,
  setErrorText,
  charSetModalOpen,
  setCharSetModalOpen,
  publishModalOpen,
  setPublishModalOpen,
  isPublishing,
  selectedFolder,
  setSelectedFolder,
  pubFolders,
  privFolders,
  showTermsError,
  setShowTermsError,
  acceptedPublishTerms,
  setAcceptedPublishTerms,
  publishContent,
  isSessionModalOpen,
  setIsSessionModalOpen,
  user,
  isLimitModalOpen,
  setIsLimitModalOpen,
  limitTitle,
  subscription,
  router,
  xlLimitModalOpen,
  setXlLimitModalOpen,
  setModel,
  tooltipModalOpen,
  setTooltipModalOpen,
  extendModalOpen,
  setExtendModalOpen,
  lastVideoModel,
  videoModel,
  handleSubmitVideoV3,
  extendVideoId,
  extendSourceVersion,
  extendInitial,
  t,
}) {
  return (
    <>
      <Modal
        isOpen={isAlertModalOpen}
        closeModal={() => setIsAlertModalOpen(false)}
        title={t('workflowSaved')}
        content={
          <>
            <img
              src="assets/create/bookmark.webp"
              alt="Promptchan bookmark example"
              className="mx-auto md:w-1/2 w-full mb-12"
            />

            <p>{t('workflowSavedBody')}</p>
          </>
        }
        confirmation2={t('openWorkflows')}
        onConfirm2={() => setBookmarkModalOpen(true)}
        confirmation={t('done')}
        onConfirm={() => setIsAlertModalOpen(false)}
      />
      <Modal
        isOpen={isErrorModalOpen}
        closeModal={() => setIsErrorModalOpen(false)}
        title={t('error')}
        content={errorText || t('somethingWentWrong')}
        confirmation={t('done')}
        onConfirm={() => setIsErrorModalOpen(false)}
      />
      <Modal
        isOpen={charSetModalOpen}
        closeModal={() => setCharSetModalOpen(false)}
        title={t('characterSet')}
        content={t('characterSetBody')}
        confirmation={t('done')}
        onConfirm={() => setCharSetModalOpen(false)}
      />
      <Modal
        isOpen={publishModalOpen}
        closeModal={() => {
          if (isPublishing) return
          setPublishModalOpen(false)
        }}
        title={t('publish')}
        content={
          <div>
            <p className="mb-3 text-base">{t('publishToA')}</p>

            <div className="mb-4">
              <label className="block text-xs font-semibold mb-1.5 opacity-90">
                <span className="inline-flex items-center gap-2">
                  <FaFolder />
                  {t('folder')}
                </span>
              </label>

              <div className="relative">
                <select
                  disabled={isPublishing}
                  value={selectedFolder}
                  onChange={(e) => setSelectedFolder(e.target.value)}
                  className="w-full rounded-lg border border-white/20 bg-[#0F0D14] px-3 py-2.5 text-white appearance-none focus:outline-none disabled:opacity-60 disabled:cursor-not-allowed"
                >
                  <optgroup label={t('publicFolders')}>
                    {pubFolders.map((f, idx) => (
                      <option key={`pub-${f}-${idx}`} value={`pub:${f}`}>
                        {f === 'Gallery' ? t('publicGallery') : f}
                      </option>
                    ))}
                  </optgroup>

                  <optgroup label={t('privateFolders')}>
                    {privFolders.map((f, idx) => (
                      <option key={`priv-${f}-${idx}`} value={`priv:${f}`}>
                        {f === 'Gallery' ? t('privateGallery') : f}
                      </option>
                    ))}
                  </optgroup>
                </select>

                <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 opacity-60">
                  ⌄
                </span>
              </div>
            </div>

            <div
              className={`mb-4 rounded-md p-2 transition ${
                showTermsError ? 'ring-1 ring-red-500/70 bg-red-500/5' : ''
              }`}
            >
              <label className="flex items-start gap-2 text-xs text-white cursor-pointer">
                <input
                  type="checkbox"
                  disabled={isPublishing}
                  checked={acceptedPublishTerms}
                  onChange={(e) => {
                    const checked = e.target.checked
                    setAcceptedPublishTerms(checked)
                    if (checked) setShowTermsError(false)
                  }}
                  className="mt-0.5 disabled:opacity-60 disabled:cursor-not-allowed"
                />

                <span className="leading-relaxed">
                  {t('publishTermsBefore')}{' '}
                  <a
                    href="/termsofservice"
                    className="underline underline-offset-2 hover:text-white"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {t('termsOfService')}
                  </a>{' '}
                  {t('publishTermsAfter')}
                </span>
              </label>

              {showTermsError && (
                <p className="mt-1 text-xs text-red-400">
                  {t('mustAcceptTerms')}
                </p>
              )}
            </div>

            <div className="flex justify-end">
              <button
                type="button"
                disabled={isPublishing}
                onClick={async () => {
                  if (isPublishing) return

                  if (!acceptedPublishTerms) {
                    setShowTermsError(true)
                    return
                  }

                  setShowTermsError(false)
                  await publishContent()
                }}
                className="inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold text-white
              bg-[var(--foreground-bg-color)] transition-transform duration-200 hover:scale-[1.05]
              disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:scale-100 width-32"
              >
                {isPublishing ? (
                  <>
                    <span
                      className="inline-block h-4 w-4 animate-spin rounded-full border-2 border-white/30 border-t-white"
                      aria-hidden="true"
                    />
                    {t('publishing')}
                  </>
                ) : (
                  <>
                    {(() => {
                      const [scope] = (selectedFolder || 'pub:Gallery').split(
                        ':',
                      )
                      return scope === 'pub' ? <FaGlobeAmericas /> : <FaLock />
                    })()}
                    {t('publish')}
                  </>
                )}
              </button>
            </div>
          </div>
        }
      />
      <Modal
        isOpen={isSessionModalOpen}
        closeModal={() => setIsSessionModalOpen(false)}
        title={t('sessionExpired')}
        content={t('sessionExpiredBody')}
        confirmation={t('refresh')}
        onConfirm={async () => {
          try {
            await getIdToken(user, true)
          } catch {}

          if (typeof window !== 'undefined') {
            window.location.reload()
          }
        }}
      />
      <Modal
        isOpen={isLimitModalOpen}
        closeModal={() => setIsLimitModalOpen(false)}
        title={limitTitle || `🚀 ${t('upgradetocontinuegenerating')}`}
        content={errorText || t('somethingWentWrong')}
        confirmation={t('upgradeandunlockbenefits')}
        onConfirm={() => {
          subscription.plan === 'Pro' || subscription.plan === 'Studio'
            ? router.push('/gems')
            : router.push('/upgrade')
        }}
      />
      <Modal
        isOpen={xlLimitModalOpen}
        closeModal={() => setXlLimitModalOpen(false)}
        title={`${t('upgradeToAccess')} 🔥`}
        content={
          <div className="text-center">
            <Link href="/upgrade">
              <img
                src="/assets/modals/xl.webp"
                alt="Upgrade for XL"
                className="rounded-xl w-2/3 mx-auto mb-2"
              />
            </Link>
            <p>{t('youveRunOut')}</p>
          </div>
        }
        confirmation={t('upgradeandunlockbenefits')}
        onConfirm={() => {
          subscription.plan === 'Pro' || subscription.plan === 'Studio'
            ? router.push('/gems')
            : router.push('/upgrade')
        }}
        confirmation2={t('useSdStyles')}
        onConfirm2={() => {
          setModel('Real')
        }}
      />
      <TooltipModal
        isOpen={tooltipModalOpen}
        closeModal={() => setTooltipModalOpen(false)}
        title={t('welcomeToCreate')}
        content={t('welcomeToCreateBody')}
        confirmation={t('startCreating')}
        onConfirm={() => setTooltipModalOpen(false)}
      />
      <ExtendModal
        isOpen={extendModalOpen}
        closeModal={() => setExtendModalOpen(false)}
        subscription={subscription}
        lorasList={null}
        setLorasList={null}
        model={lastVideoModel ?? videoModel}
        setIsLimitModalOpen={setIsLimitModalOpen}
        setErrorText={setErrorText}
        setIsErrorModalOpen={setIsErrorModalOpen}
        user={user}
        handleSubmitVideoV3={handleSubmitVideoV3}
        // Only the video the person chose. This mount is the feed's (layout B), where `docRef` holds the LAST
        // generation's ids: falling back to them sent a picture's id as the source (12 October 2026).
        extendId={extendVideoId}
        sourceVersion={extendSourceVersion}
        initial={extendInitial}
      />
    </>
  )
}
